"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
const RowCard = _ref => {
  let {
    children = '',
    onChangeCheckBox = () => {},
    checkboxLabel = 'Use this payment method',
    enableCheckBox = true,
    icon,
    checkboxChecked,
    className,
    others
  } = _ref;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_core.Box, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.rootRowCard, className)
  }, others), children, enableCheckBox && /*#__PURE__*/_react.default.createElement(_core.FormGroup, null, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    className: classes.checkBoxWrapper,
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      checked: checkboxChecked,
      color: "primary",
      onChange: onChangeCheckBox
    }),
    label: /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: classes.checkboxLabel
    }, checkboxLabel)
  })), icon);
};
var _default = exports.default = RowCard;